
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import Datepicker from 'vuejs-datepicker';
import { BasePoI } from '../backend/backendapi';

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'MarkerDetails',
  components: {
    Datepicker,
  },
})
export default class MarkerDetails extends Vue {
  @Prop({ required: true })
  private readonly poi!: BasePoI;
  @Prop({ required: true })
  readonly edit!: boolean;

  get selectedPoi(): BasePoI {
    return { ...this.poi } as BasePoI;
  }

  get flow(): string {
    if (!this.edit) {
      return 'View Details';
      // return this.$t('map.details.marker.viewDetails').toString();
    }
    if (this.selectedPoi.id) {
      return 'Edit';
      // return this.$t('map.details.marker.edit').toString();
    } else {
      return 'Add';
      // return this.$t('map.details.marker.add').toString();
    }
  }

  clearSelection() {
    // //this.markers = [];
    // if (this.selectedPoi.id === undefined) {
    //   const points: MapPoint[] = [];
    //   // Geographic coordinates of the LineString
    //   this.markers.forEach(function (obj) {
    //     if (obj.id !== undefined && obj.id !== "")
    //       points.push(obj);
    //   });
    //   this.markers = points;
    // }
    // this.selectedPoi = new BasePoI();
    // // this.flow = "";//TODO uncomment
  }

  printInformation() {
    // this.service.printPoI(this.selectedIndex.id as string);
  }

  public saveInformation() {
    if (this.flow === 'Edit') {
      this.updateSelected();
    } else {
      // Add new marker flow goes here.
      this.createSelected();
    }
  }

  createSelected() {
    //     if (this.selectedIndex.id === undefined || this.selectedIndex.id === "") {
    //         this.selectedIndex.description = this.tempDescription;
    //         switch (this.selectedIndex.type) {
    //             case TypePOI.Waterpoint:
    //                 this.service.createPoI(this.selectedIndex as WaterPoint);
    //                 break;
    //             case TypePOI.FireAlarmSystem:
    //                 this.service.createPoI(this.selectedIndex as AlarmSystem);
    //                 break;
    //             case TypePOI.Resource:
    //                 this.service.createPoI(this.selectedIndex as Resource);
    //                 break;
    //             case TypePOI.ObjectPlan:
    //                 this.service.createPoI(this.selectedIndex as ObjectPlan);
    //                 break;
    //         }
    //     }
    //     this.fetchAndClear();
  }

  updateSelected() {
    // if (this.selectedIndex.id !== undefined && this.selectedIndex.id !== "") {

    //     //TODO temporary fix to overcome the property serialization issue
    //     (this.selectedIndex.file as BaseFile[]).forEach(function (file) {
    //         file.properties = "";
    //     });

    //     this.selectedIndex.description = this.tempDescription;
    //     switch (this.selectedIndex.type) {
    //         case TypePOI.Waterpoint:
    //             this.service.updatePoI(this.selectedIndex as WaterPoint);
    //             break;
    //         case TypePOI.FireAlarmSystem:
    //             this.service.updatePoI(this.selectedIndex as AlarmSystem);
    //             break;
    //         case TypePOI.Resource:
    //             this.service.updatePoI(this.selectedIndex as Resource);
    //             break;
    //         case TypePOI.ObjectPlan:
    //             this.service.updatePoI(this.selectedIndex as ObjectPlan);
    //             break;
    //     }
    // }
    // this.fetchAndClear();
  }

  public changeTypeOfPoI() {
    // if (this.selectedIndex.type == TypePOI.Waterpoint) {
    //     this.selectedIndex = new WaterPoint(this.selectedIndex);
    //     this.markers[this.markers.length - 1].type = TypePOI.Waterpoint;
    // }
    // else if (this.selectedIndex.type == TypePOI.FireAlarmSystem) {
    //     this.selectedIndex = new AlarmSystem(this.selectedIndex);
    //     this.markers[this.markers.length - 1].type = TypePOI.FireAlarmSystem;
    // }
    // else if (this.selectedIndex.type == TypePOI.Resource) {
    //     this.selectedIndex = new Resource(this.selectedIndex);
    //     this.markers[this.markers.length - 1].type = TypePOI.Resource;
    // }
    // else if (this.selectedIndex.type == TypePOI.ObjectPlan) {
    //     this.selectedIndex = new ObjectPlan(this.selectedIndex);
    //     this.markers[this.markers.length - 1].type = TypePOI.ObjectPlan;
    // }
    // else {
    //     this.selectedIndex = new BasePoI();
    // }
    // return;
  }
}
